import { render, staticRenderFns } from "./friend-link.vue?vue&type=template&id=7cc194af&"
import script from "./friend-link.vue?vue&type=script&lang=js&"
export * from "./friend-link.vue?vue&type=script&lang=js&"
import style0 from "./friend-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports